(function ($, Drupal, once) {
  'use strict';
  Drupal.behaviors.weaver_tailwind_collapse = {

    anchorOpenCollapse: function() {
      const url = window.location.href;
      const anchorPattern = /#(.*)/;
      const match = url.match(anchorPattern);

      if (!anchorPattern.test(url)) {
        return;
      }

      const anchor = match[1];
      const anchorElement = document.getElementById(anchor);

      if (anchorElement == null) {
        return;
      }

      if (anchorElement.classList.contains('paragraph--type--ptb-checklist') == false) {
       
        if (anchorElement.dataset.tweCollapseItem == undefined) {
          return;
        }

        let collapse = anchorElement;

        this.openCollapse(collapse);
        anchorElement.scrollIntoView();
      
      } else {

        const tab = Drupal.behaviors.weaver_tailwind_tabs.getTabOfChecklist(anchorElement);

        // checklist may or may not be inside tab and if so, needs to switch to the tab and expand checklist
        if (tab == null) {

          let collapse = anchorElement.querySelector('.collapse');
          if (collapse == null) {
            return;
          }

          this.openCollapse(collapse);
          collapse.scrollIntoView();
        
        } else {
        
          Drupal.behaviors.weaver_tailwind_tabs.scrollToChecklist(tab);
        }
      }
    },

    initializeCollapses: function() {
      let collapseTriggers = document.querySelectorAll('[data-twe-collapse-init]');
      if (collapseTriggers.length <= 0) {
        return;
      }

      collapseTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          this.toggleIcons(e.target.closest('[data-twe-collapse-init]'));
        });
      });
    },

    initializeOnPageAnchorLinks: function() {
      const onPage = document.getElementById('ptb-on-page');
      if (onPage == null) {
        return;
      }

      const onPageLinks = onPage.querySelectorAll('a');
      if (onPageLinks <= 0) {
        return;
      }

      onPageLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
          if (window.screen.width < 1200) {
            this.toggleCollapse(onPage);
          }
        });
      });
    },

    initializeOpenAllButtons: function() {
      const openAllButtons = document.querySelectorAll('[data-ptb-toggle="open-all"]');
      if (openAllButtons.length <= 0) {
        return;
      }

      openAllButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          this.openAll(e.target);
        });
      });
    },

    initializeKeyboardShortcuts: function() {
      document.addEventListener('keydown', (e) => {
        if ((e.code == 'Enter' || e.code == 'NumpadEnter') && e.target.dataset.tweCollapseInit != undefined) {
          let target = document.querySelector(e.target.dataset.tweTarget);
          this.toggleCollapse(target);
        }

        if ((e.code == 'Enter' || e.code == 'NumpadEnter') && e.target.dataset.ptbToggle == 'open-all') {
          this.openAll(e.target);
        }

        if (e.keyCode == 70 && (e.metaKey || e.ctrlKey)) {
          this.openAllCollapses();
        }

      });
    },

    initializeSidebarHelp: function() {
      const help = document.getElementById('sidebar-help');
      if (help == null) {
        return;
      }

      const helpCollapse = help.querySelector('[data-twe-collapse-item]');
      if (helpCollapse == null) {
        return; 
      }

      // let helpCollapseItem = twe.Collapse.getOrCreateInstance(helpCollapse);
      helpCollapse.addEventListener('show.twe.collapse', (e) => {
        help.dataset.ptbExpanded = 'true';
      });
      helpCollapse.addEventListener('hide.twe.collapse', (e) => {
        help.dataset.ptbExpanded = 'false';
      });
    },

    openAll: function(trigger) {
      const accordionGroup = trigger.closest('.paragraph--type--ptb-accordion-group');
      if (accordionGroup == null) {
        return;
      }

      const accordionItems = accordionGroup.querySelectorAll('.paragraph--type--ptb-accordion-item .collapse');
      if (accordionItems.length <= 0) {
        return;
      }

      accordionItems.forEach((item) => {
        this.openCollapse(item);
        trigger.remove();
      });
    },

    openAllCollapses: function() {
      const collapses = document.querySelectorAll('.paragraph--type--ptb-accordion-item [data-twe-collapse-item]');
      if (collapses.length <= 0) {
        return;
      }

      collapses.forEach((collapse) => {
        this.openCollapse(collapse);
      });
    },

    openCollapse: function(element) {
      let collapseItem = twe.Collapse.getOrCreateInstance(element);
      console.log(twe.Collapse);
      collapseItem.show();
      this.toggleIcons(element, 'open');
    },

    toggleCollapse: function(element) {
      let collapseItem = twe.Collapse.getOrCreateInstance(element);
      collapseItem.toggle();
      this.toggleIcons(element);
    },

    toggleIcons: function(trigger, state=null) {
        let icons = trigger.parentNode.querySelectorAll('.collapse-icon');
        if (icons.length <= 0) {
          return;
        }

        icons.forEach(icon => {

          if (state == null) {
            icon.classList.toggle('hidden');
          } else {
            if (icon.dataset.ptbCollapse == state) {
              icon.classList.add('hidden');
            } else {
              icon.classList.remove('hidden');
            }
          }
        });
    },

    attach: function (context, settings) {

      $(once('weaver_tailwind_collapse', 'body', context)).each(function () {
        const weaver_tailwind_collapse = Drupal.behaviors.weaver_tailwind_collapse;

        weaver_tailwind_collapse.anchorOpenCollapse();
        weaver_tailwind_collapse.initializeCollapses();
        weaver_tailwind_collapse.initializeKeyboardShortcuts();
        weaver_tailwind_collapse.initializeOnPageAnchorLinks();
        weaver_tailwind_collapse.initializeOpenAllButtons();
        weaver_tailwind_collapse.initializeSidebarHelp();
      });
    }
  };
})(jQuery, Drupal, once);